import { render, staticRenderFns } from "./StudentQuestionsImgNegative.vue?vue&type=template&id=69a041e6&"
import script from "./StudentQuestionsImgNegative.vue?vue&type=script&lang=ts&"
export * from "./StudentQuestionsImgNegative.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports